<div class="mb-1" [ngClass]="{'mt-1rem':!isArchive}">
  <div class="ptb-archive" *ngIf="isArchive">
    <div class="mt-12 ml-1-5 archive-banner width-max-content">
      <div class="archive-btn">
        <span class="version-general-header">Archive Version : {{archiveVersion}}</span>
      </div>
      <div role="button" class="back-close-btn" tabindex="0" (click)="BackToCurrentContent()" (keyup.enter)="BackToCurrentContent()" tabindex="0">
        <img src="../../../assets/icons/arrow-left-blue.svg" class="current-content-back-arrow-icon" alt="Arrow Left">
        <span class="underline">Back to Current GARS Version</span>
      </div>
    </div>
  </div>
  <div class="generalPage">
    <div class="help-content-container print-content print-all-content">
      <h1 class="top-heading content-blue" role="heading" aria-level="2">{{help_ContactUsHeader}}</h1>
      <div class="answerHome font-16 content-blue width-100" [innerHTML]="help_ContactUsDesc"></div>
    </div>
  </div>
</div>
